import React from 'react';
import * as PropTypes from 'prop-types';
import { constants } from 'cv-react-core';
import { ThreeOneOverForm as ThreeOneOverFormBase } from 'cv-library-react-web';

import getStyles from './ThreeOneOverForm.styles';

const ThreeOneOverForm = (props) => {
    const {
        formElements,
        onResizeStop,
        ...rest
    } = props;
    const styles = getStyles();
    const { ui } = constants;

    const handleResizeStop = (e, dir, ref) => {
        const viewId = ref.getAttribute('viewid');
        const {
            style: {
                width,
                height,
            },
        } = ref;
        onResizeStop(viewId, width, height);
    };

    return (
        <ThreeOneOverFormBase
            contextStyles={ styles }
            formElements={ formElements }
            onResizeStop={ handleResizeStop }
            scrollIdentifier={ ui.SCROLL_CONTAINER }
            { ...rest } />
    );
};

ThreeOneOverForm.propTypes = {
    formElements: PropTypes.arrayOf(PropTypes.element),
    onResizeStop: PropTypes.func,
};

ThreeOneOverForm.defaultProps = {
    formElements: {},
};

export default ThreeOneOverForm;
